import { transformDocumentNumber } from '@/components/custom/erp';
import { FormFieldState } from '../hooks';

export const transformDetailRows = (detailRows: MuaHangRecord[]) => {
  return detailRows.map((row: MuaHangRecord, index: number) => ({
    line: index + 1,
    tk: row.tk_data?.uuid || '',
    ma_kh: row.ma_kh_data?.uuid || '',
    ps_no_nt: row.ps_no_nt || 0,
    ps_no: row.ps_no_nt || 0,
    ps_co_nt: row.ps_co_nt || 0,
    ps_co: row.ps_co_nt || 0,
    nh_dk: row.nh_dk || '',
    dien_giai: row.dien_giai || '',
    so_ct0: row.so_ct0 || '',
    ngay_ct0: row.ngay_ct0 || '',
    ma_bp: row.ma_bp_data?.uuid || '',
    ma_vv: row.ma_vv_data?.uuid || '',
    ma_hd: row.ma_hd_data?.uuid || '',
    ma_dtt: row.ma_dtt_data?.uuid || '',
    ma_ku: row.ma_ku_data?.uuid || '',
    ma_phi: row.ma_phi_data?.uuid || '',
    ma_sp: row.ma_sp_data?.uuid || '',
    ma_lsx: row.ma_lsx_data?.uuid || '',
    ma_cp0: row.ma_cp0_data?.uuid || ''
  }));
};

export const transformTaxRows = (taxRows: MuaHangRecord[]) => {
  return taxRows.map((row: MuaHangRecord, index: number) => ({
    line: index + 1,
    so_ct0: row.so_ct0 || '',
    so_ct2: row.so_ct2 || '',
    ngay_ct0: row.ngay_ct0 || '',
    ma_thue: row.ma_thue || '',
    ma_mau_ct: row.ma_mau_ct_data?.uuid || '',
    ma_mau_bc: row.ma_mau_bc || '',
    ma_tc_thue: row.ma_tc_thue || '',
    ma_kh: row.ma_ncc_data?.uuid || '',
    ten_kh_thue: row.ma_ncc_data?.customer_name || '',
    dia_chi: row.ma_ncc_data?.address || '',
    ma_so_thue: row.ma_ncc_data?.tax_code || '',
    ten_vt_thue: row.ten_vt_thue || '',
    t_tien_nt: row.t_tien_nt || 0,
    tk_thue_no: row.tk_thue_no_data?.uuid || '',
    t_thue_nt: row.t_thue_nt || 0,
    ma_kh9: row.customer_code_data?.uuid || '',
    ma_tt: row.ma_tt_data?.uuid || '',
    ghi_chu: row.ghi_chu || '',
    ma_bp: row.ma_bp_data?.uuid || '',
    ma_vv: row.ma_vv_data?.uuid || '',
    ma_hd: row.ma_hd || '',
    ma_dtt: row.ma_dtt || '',
    ma_ku: row.ma_ku_data?.uuid || '',
    ma_phi: row.ma_phi_data?.uuid || '',
    ma_sp: row.ma_sp_data?.uuid || '',
    ma_lsx: row.ma_lsx_data?.uuid || '',
    ma_cp0: row.ma_cp_data?.uuid || ''
  }));
};

export const transformFormData = (data: MuaHangRecord, state: FormFieldState, ...rest: MuaHangRecord[]) => {
  const detail = transformDetailRows(rest[0]);
  const tax = transformTaxRows(rest[1]);
  return {
    // FormField
    ...data,

    ty_gia: (data.ty_gia ? parseFloat(data.ty_gia) : 1).toFixed(2) || 1.0,

    // Chung tu
    ...transformDocumentNumber(state.quyenChungTu, state.soChungTu),

    // Input Table
    chi_tiet_items: detail,
    thue_items: tax
  };
};
